<template>
  <generic-modal :title="$t('node')" :buttons="buttons" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("title") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.title" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div>
      <div class="notification is-danger mt-5" v-if="error">
        <p v-html="error"></p>
      </div>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
// import "orgchart/dist/js/jquery.orgchart";
// import "orgchart/dist/css/jquery.orgchart.min.css";

export default {
  name: "NodeModal",
  components: {
    GenericModal,
    GenericUploader,
    GenericDropdown,
  },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(node) {
      let v = this;
      v.set_initial_state();
      if (node) v.meta = { ...node };

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$emit("save", data);
      v.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  created() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
